import _typeof from "@babel/runtime/helpers/esm/typeof";
import * as React from 'react';
export default function useMergedConfig(propConfig, templateConfig) {
  return React.useMemo(function () {
    var support = !!propConfig;
    return [support, Object.assign(Object.assign({}, templateConfig), support && _typeof(propConfig) === 'object' ? propConfig : null)];
  }, [propConfig]);
}